import ComposedCommonWebSections
	from '@components/RequestForm/composedSections/ComposedCommonWebSections/ComposedCommonWebSections';

const ComposedLegacySections = ComposedCommonWebSections;

export default ComposedLegacySections;
